import type { ReactNode } from 'react'

import { Modal } from '@/src/elements/modal/Modal'
import { Typography } from '@/src/elements/text/Typography'
import { useTranslate } from '@/src/lang/useTranslate'

type TIntentionFormScreenModalProps = {
  isOpen: boolean
  onConfirm: VoidFunction
  onCancel: VoidFunction
}

export const IntentionFormScreenModal = ({
  isOpen,
  onConfirm,
  onCancel,
}: TIntentionFormScreenModalProps): ReactNode => {
  const { t } = useTranslate()

  return (
    <Modal
      cancelText={t('word.cancel')}
      classNames={{ body: 'gap-3' }}
      confirmText={t('word.remove')}
      colors="danger"
      onCancel={onCancel}
      onConfirm={onConfirm}
      showModal={isOpen}
      showCancelButton
      title={t('intention.delete.delete')}
    >
      <Typography>{t('intention.delete.confirm-message1')}</Typography>
      <Typography>{t('intention.delete.confirm-message2')}</Typography>
    </Modal>
  )
}
